module.exports = __webpack_public_path__ + "media/images/bg-modal-basic-header-3e6c3d94279e5a83e955330e5969ff55.png";